import { FunctionComponent, Suspense, useMemo, useState } from 'react';
import Style                                              from './Sidebar.style';
import { Menu, SiderProps }                               from 'antd';
import { linkHandler }              from 'Utils';
import { useDispatch, useSelector } from 'react-redux';
import Actions                      from 'Redux/Actions';
import { Icon, Link }                                     from 'View/Common';
import React                                              from 'react';
import { getCurrentUser }                                 from '../../../Redux/Queries';
import { logo }                           from 'Public/Assets';
import { icon }                           from 'Public/Assets';
import { useEffect } from 'react';
import { useIsMobile } from 'View/HookApi';

export const Sidebar: FunctionComponent<SiderProps> = (props) => {
  const dispatch = useDispatch();
  const { role = null } = useSelector(getCurrentUser);
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useState(isMobile);

  useEffect(() => {
    setCollapsed(isMobile);
  }, [isMobile]);

  const handleLogout = () => {
    dispatch(Actions.logout());
  };

  const sidebarEntries = useMemo(() => {
    if(!role) {
      return [];
    }

    return linkHandler.getSideBoard().filter(entry => {
      if(entry.access) {
        const accessKeys = entry.access.map(({ key }) => key);
        if(!accessKeys.includes(role)) {
          return false;
        }
      }
      return true;
    }).map(entry => {
      if (entry.key === 'logout') {
        return {
          key: entry.key,
          className: 'logoutButton',
          label: (
            <Link to={linkHandler.get(entry.key)} onClick={handleLogout}>
              {(entry.icon) ? <Icon type={entry.icon}/> : null}
              <span>{entry.label}</span>
            </Link>
          )
        };
      }
      const renderItem = () => {
        let SideboardAdditionalComponent = null;
        if (entry.sidebar && entry.sidebar.hasOwnProperty('render')) {
          SideboardAdditionalComponent = entry.sidebar.render;
        }

        return (
          <React.Fragment key={`renderItem_${entry.key}`}>
            {(entry.icon) ? <Icon type={entry.icon}/> : null}
            <span>{entry.label} {SideboardAdditionalComponent ?
              <Suspense fallback={null}>
                {/* @ts-ignore */}
                <SideboardAdditionalComponent/>
              </Suspense>
              : null}
            </span>
          </React.Fragment>
        );
      };

      return {
        key: entry.key,
        className: `menu-entry-${entry.key}`,
        label: <Link href={entry.key}>{renderItem()}</Link>,
      };

    });
  }, [role]);

  return (
    <Style collapsible collapsed={collapsed} onCollapse={setCollapsed} width="256" collapsedWidth="48" {...props}>
      <div className="sidebarLogo">
        { collapsed ? <img src={icon}/> : <img src={logo}/> }
      </div>
      <Menu
        items={sidebarEntries}
      />
    </Style>
  );

};
